import backend from "apps/shared/backend";

function onSuccessCallback(formContainer, _) {
  formContainer.innerHTML = "<br/><h1>Danke</h1><p>Wir haben Ihr Anliegen erhalten!</p>";
}

export default function(form_identifier, feedbackUrl, onSuccess = onSuccessCallback) {
  const formContainer = document.getElementById(form_identifier);
  const form = formContainer.querySelector("form");
  const submitButton = form.querySelector("input[type=submit]")

  function showErrors(errors=null) {
    const container = form.querySelector('.feedback-form__errors');
    container.innerHTML = ''; // remove all existing children
    let child = null;
    
    if (errors && errors.length > 0) {
      for (let error of errors) {
        child = document.createElement('div');
        child.innerHTML = error;
        container.appendChild(child);
      }
    } else {
      container.innerHTML = "Ein unbekannter Fehler ist aufgetreten!";
    }

    // reset google captcha
    if(window.grecaptcha) {
      grecaptcha.reset();
      window.handle_recaptcha_expired();  // hides submit button
    }
  }

  async function sendFeedback() {
    const formData = new FormData(form);

    try {
      // The last two arguments to backend:
      // undefined in order to set extraOptions parameter to default value
      // null in order to explicitely delete contentType
      // this ensures that the default contentType "application/json" is not used
      // instead, the correct contentType is set automatically by Axios based on the formData object
      const data = await backend(feedbackUrl, "POST", formData, undefined, null);
      if (data && data.data && data.data.success) {
        onSuccess(formContainer, data.data);
      } else {
        showErrors(data?.data?.errors);
      }
    } catch (e) {
      console.error(e);
      showErrors();
    } finally {
      // re-enable submit button
      submitButton.disabled = false;
      submitButton.classList.remove("feedback-form-button--disable");
    }
  }

  form.addEventListener("submit", event => {
    event.preventDefault();
    // disable submit button
    submitButton.disabled = true;
    submitButton.classList.add("feedback-form-button--disable");

    sendFeedback();
  })
}
